import DatePicker, { ReactDatePickerProps } from 'react-datepicker';

const getDate = dateValue => {
  if (!dateValue) {
    return null;
  }

  let d = dateValue;
  if (!dateValue.split) {
    d = dateValue.toISOString();
  }

  const parts = d.split('T')[0].split('-').map(Number);
  const year = parts[0];
  const month = parts[1] - 1;
  const day = parts[2];

  // Construct the new Date object
  const date = new Date(year, month, day);
  return date;
};

const DatePickerFieldWithHeader = ({
  disableField,
  name,
  value,
  minDate,
  maxDate,
  onChange,
  showTimeSelect,
  timeIntervals,
  dateFormat,
  isRestrictBackdate,
  disabled,
  showMonthYearPicker,
  isClearable,
  dateOnly = false,
}: {
  [key: string]: any;
}) => {
  const fieldProps: ReactDatePickerProps = {
    showTimeSelect: showTimeSelect,
    timeIntervals: timeIntervals || 15,
    minDate: minDate || null,
    maxDate: maxDate,
    dateFormat: dateFormat || 'MM/dd/yyyy',
    selected: dateOnly ? getDate(value) : value && new Date(value),
    onChange: (val: any) => {
      onChange(name, val);
    },
    disabled,
    showMonthYearPicker,
    isClearable,
    showYearDropdown: true,
    showMonthDropdown: true,
  };

  if (!isRestrictBackdate) {
    fieldProps.onKeyDown = e => {
      e.preventDefault();
    };
  }

  return (
    <div>
      <div>{disableField}</div>
      <div>
        <DatePicker {...fieldProps} />
      </div>
    </div>
  );
};

export default DatePickerFieldWithHeader;
